"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDesktopDropdownMenu = void 0;
const classnames_1 = __importDefault(require("classnames"));
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
const DropdownSummary_1 = require("./DropdownSummary");
const Menu_styles_1 = require("./Menu.styles");
const SimpleDesktopDropdownMenuLink_1 = require("./SimpleDesktopDropdownMenuLink");
const List = styled_components_1.default.ul `
	visibility: ${(p) => (p.menuOpen ? "visible" : "hidden")};
	&:hover {
		visibility: visible;
	}
	display: block;
	list-style-type: none;
	padding-inline-start: 0;
	background: ${(p) => p.theme.palette.background.default};
	margin: 0;
	padding: 0 8px 8px 8px;
	position: absolute;
	z-index: 9002;
	right: ${(p) => (p.rightAlign ? 0 : "initial")};

	&.ar {
		li {
			text-align: right;
		}
	}

	li {
		text-align: left;
		&.center {
			text-align: center;
		}
	}

	a {
		padding: 12px 16px;
		white-space: nowrap;
		&:hover {
			color: ${(p) => p.theme.palette.text.primaryHover || p.theme.palette.text.primary};
		}

		${(p) => p.theme.breakpoints.up("lg")} {
			font-size: 12px;
		}
	}

	&.drop-center {
		a {
			padding: 8px 16px;
		}
	}
`;
const SimpleDesktopDropdownMenu = ({ links = [], summaryNode, textAlignCenter, dropdownAlignCenter, controlMenuOpen = false, controlMenuOpenValue = false, disableMouseLeave, menuId = "", rightAlign, disableHrefTemplate, }) => {
    const { open: myMenuOpen, setActiveMenu } = (0, shared_1.useMyActiveMenu)(menuId);
    const [manualMenuOpen, setManualMenuOpen] = (0, react_1.useState)(controlMenuOpen ? controlMenuOpenValue : myMenuOpen);
    const locale = (0, epic_games_nav_shared_1.useLocalizationLocale)();
    const [summaryWidth, setSummaryWidth] = (0, react_1.useState)(0);
    const [summaryRight, setSummaryRight] = (0, react_1.useState)(0);
    const [menuWidth, setMenuWidth] = (0, react_1.useState)(0);
    const openMenu = (0, shared_1.useOpenMenu)(menuId);
    const closeMenu = (0, react_1.useCallback)(() => {
        if (disableMouseLeave)
            return;
        setManualMenuOpen(false);
        setActiveMenu("");
    }, [disableMouseLeave, setManualMenuOpen]);
    const menuOpen = controlMenuOpen ? manualMenuOpen : myMenuOpen;
    const toggleMenu = (0, shared_1.useToggleMenu)(menuOpen, controlMenuOpen ? setManualMenuOpen : setActiveMenu, menuId);
    const summaryRef = (0, react_1.useCallback)((node) => {
        if (!dropdownAlignCenter)
            return;
        if (node !== null) {
            const { width, right } = node.getBoundingClientRect();
            setSummaryWidth(width);
            const innerWidth = window_or_global_1.default.innerWidth;
            setSummaryRight(innerWidth - right);
        }
    }, [dropdownAlignCenter, setSummaryWidth, setSummaryRight]);
    const menuRef = (0, react_1.useCallback)((node) => {
        if (!dropdownAlignCenter)
            return;
        if (node !== null) {
            setMenuWidth(node.getBoundingClientRect().width);
        }
    }, [dropdownAlignCenter, setMenuWidth]);
    // Center the dropdown on the center point of the summary
    let translate = dropdownAlignCenter && !rightAlign ? (menuWidth - summaryWidth) / 2 : 0;
    if (rightAlign) {
        translate = summaryRight - summaryWidth / 2;
    }
    const classes = (0, classnames_1.default)("simple-menu-list", dropdownAlignCenter ? "drop-center" : "drop-left", menuId ? `menu-${menuId}` : "", locale);
    return (react_1.default.createElement(Menu_styles_1.Menu, { role: "menu", static: true, onMouseEnter: openMenu, onMouseLeave: closeMenu },
        summaryNode ? (react_1.default.createElement(DropdownSummary_1.DropdownSummary, { summaryRef: summaryRef, menuId: menuId, openMenu: openMenu, onKeyUp: toggleMenu, disableIndicator: true }, summaryNode)) : (""),
        react_1.default.createElement(List, { role: "menu", onMouseEnter: openMenu, ref: menuRef, menuOpen: controlMenuOpen ? controlMenuOpenValue : menuOpen, rightAlign: rightAlign, style: { transform: `translateX(-${translate}px)` }, className: classes }, links.map((link) => {
            if (!link)
                return;
            const key = link.key || link.title;
            if (!key)
                return;
            return (react_1.default.createElement("li", { key: key, className: textAlignCenter ? "center" : "" },
                react_1.default.createElement(SimpleDesktopDropdownMenuLink_1.SimpleDesktopDropdownMenuLink, { link: link, locale: locale, disableHrefTemplate: disableHrefTemplate })));
        }))));
};
exports.SimpleDesktopDropdownMenu = SimpleDesktopDropdownMenu;
//# sourceMappingURL=SimpleDesktopDropdownMenu.js.map